import { OnInit, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { BillingInvoiceManualService } from 'src/app/services/billing/billing-invoice-manual/billing-invoice-manual.service';
import { BillingManualInvoiceLogItem } from 'src/app/model/billing/billing-manual-invoice-log-item';

@Component({
  selector: 'app-billing-manual-invoice-log-dialog',
  templateUrl: 'billing-manual-invoice-log-dialog.component.html',
  styleUrls: ['./billing-manual-invoice-log-dialog.component.css']
})

export class BillingManualInvoiceLogDialogComponent implements OnInit {

  logs: BillingManualInvoiceLogItem[] = [];

  loading: boolean = false;

  constructor(private billingInvoiceManualService: BillingInvoiceManualService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<BillingManualInvoiceLogDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public billingManualInvoiceId: number) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    await this.getLogs();
  }

  private async getLogs() {
    try {
      this.loading = true;
      this.logs = await this.billingInvoiceManualService.getBillingManualInvoiceLog(this.billingManualInvoiceId);
    } catch (err) {
      const error = err as any;
      this.notificationToastService.error(JSON.stringify(error.error), 'Logs de factura manual');
    } finally {
      this.loading = false;
    }
  }
}
